import React, { useEffect, useContext } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import axios from 'axios';

import '../public/css/publicationMap.css';

// api
import api from '../config/services';

// components
import MapTool from '../components/map/MapTool';
import MapContainer from '../components/map/MapContainer';
import PopUpModal from '../components/map/PopUpModal';

// store
import { StoreContext } from '../store/StoreProvider';
import Act from '../store/actions';

// format points for cluster, include points and clusters
const generatePointsForCluster = (publicationData) => {
	const prePoints = [];
	publicationData.forEach((item) => {
		const lat = parseFloat(item.lat);
		const long = parseFloat(item.long);
		const found = prePoints.find(
			(info) => info.properties.position[0] === lat && info.properties.position[1] === long
		);
		if (!found) {
			prePoints.push({
				type: 'Feature',
				properties: {
					cluster: false,
					position: [lat, long],
					location: item.location,
					locId: item.locId,
					pubIds: [item.pubId],
					publication: [item.publication],
					intensity: 1,
				},
				geometry: {
					type: 'Point',
					coordinates: [long, lat],
				},
			});
		} else {
			found.properties.pubIds.push(item.pubId);
			found.properties.intensity += 1;
			found.properties.publication.push(item.publication);
		}
	});
	return prePoints;
};

const PublicationMap = () => {
	const [state, dispatch] = useContext(StoreContext);
	const { map } = state;
	const { fileExporting, pageLoading } = map;

	useEffect(() => {
		dispatch({
			type: Act.LOADING_PAGE,
			pageLoading: true,
		});
		// isMountedRef.current = true;
		axios.get(api.getPublicationMapV2).then((response) => {
			// fetch data successifully
			if (response.status === 200 && response.data) {
				const publicationData = response.data.data;
				dispatch({
					type: Act.SET_PUB_DATA,
					publicationData,
				});
				// set pointsInfo for cluster
				const points = generatePointsForCluster(publicationData);
				dispatch({
					type: Act.SET_CLUSTER_POINTS,
					clusterPoints: points,
				});

				const markerInfo = points.map((p) => p.properties);
				dispatch({
					type: Act.SET_MAP_DATA,
					mapData: markerInfo,
				});
				dispatch({
					type: Act.LOADING_PAGE,
					pageLoading: false,
				});
			}
		});
	}, [dispatch]);

	useEffect(
		() =>
			// 離開頁面時清空資料
			() => {
				dispatch({
					type: Act.MAP_INIT,
				});
			},
		[]
	);

	return (
		<div style={{ height: 'calc(100vh - 87px)', width: '100%' }} className="map_container">
			{/* loading icon display */}
			<Dimmer active={fileExporting} inverted>
				<Loader inverted content="Downloading" size="massive" />
			</Dimmer>
			<Dimmer active={pageLoading} inverted>
				<Loader inverted content="Loading" size="massive" />
			</Dimmer>

			{/* map tool for option setting and map marker color legend */}
			<MapTool />

			{/* map container : SearchInput component is inside the MapContainer */}
			<MapContainer />

			{/* popUp modal */}
			<PopUpModal />
		</div>
	);
};

export default PublicationMap;
